module.exports = __webpack_public_path__ + "static/media/29BDOS10.65fa4ff0.jpg";